
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investor/[slug]",
      function () {
        return require("private-next-pages/investor/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investor/[slug]"])
      });
    }
  